import { Form, Formik } from "formik";
import { Col, InputGroup, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import photo1 from "../../images/writingpad.svg";
import { formatCurrency } from "../../libs/utils";
import "../AdminDashboard.scss";

const schema = yup.object({
  salary: yup.number().required("Salary is required"),
  contribution: yup
    .number()
    .required("Contribution is required")
    .min(0, "Min is 0")
    .max(100, "Max is 100"),
});

const calculator = (props) => {
  const calculateContribution = (values) => {
    if (!values.salary || !values.contribution) {
      return 0;
    }
    return (Number(values.salary) * Number(values.contribution)) / 100;
  };
  const calculateEarnings = (values) => {
    if (!values.salary || !values.contribution) {
      return 0;
    }
    let contributionAmount = calculateContribution(values);
    let taablFee = contributionAmount * 0.06;
    return (contributionAmount * Number(values.stockRange)) / 100 - taablFee;
  };
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="d-flex position-relative">
        <img
          src={photo1}
          height="800"
          width="420"
          className="img-fluid"
          alt="money calculator"
        />
        <div className="image-overlay p-3">
          <div className={`d-flex flex-column divcalc`}>
            <div className="heading text-center mt-2 text-gray">
              Taabl Calculator
            </div>
            <div className="text-gray form-calculator text-center">
              See what you can earn with your ESPP
            </div>
            <div className="mt-3">
              <Formik
                validationSchema={schema}
                initialValues={{
                  salary: 100000,
                  contribution: 25,
                  stockRange: 15,
                }}
              >
                {({ values, setFieldValue, isValid }) => (
                  <Form className="w-100">
                    <Row>
                      <Col xs={7}>
                        <FormikTextField
                          size="lg"
                          controlId="salary"
                          label="Salary"
                          type="number"
                          name="salary"
                          placeholder=" "
                          inputGroupPrepend={
                            <InputGroup.Text id="basic-addon2">
                              $
                            </InputGroup.Text>
                          }
                          className="mb-3"
                        />
                      </Col>
                      <Col xs={5}>
                        <FormikTextField
                          size="lg"
                          controlId="contribution"
                          label="Contribution"
                          type="number"
                          name="contribution"
                          placeholder=" "
                          className="mb-3"
                          inputGroupAppend={
                            <InputGroup.Text id="basic-addon2">
                              %
                            </InputGroup.Text>
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <span htmlFor="customRange1" className="form-calculator">
                        Discount <b>{values?.stockRange}%</b>
                      </span>
                    </Row>

                    <input
                      type="range"
                      className="form-range"
                      id="stockRange"
                      min="10"
                      max="50"
                      value={values.stockRange}
                      onChange={(e) => {
                        setFieldValue(
                          "stockRange",
                          Number(e.target.value),
                          true
                        );
                      }}
                    />

                    <Row>
                      <div className="form-calculator">
                        Taabl's Contribution {"  "}
                        <b>{formatCurrency(calculateContribution(values))} </b>
                      </div>
                    </Row>
                    <Row className="mt-3">
                      <div className="form-calculator"> Expected Earnings</div>
                    </Row>

                    <div className="pic-money-box">
                      <span className="earning pe-2">
                        {formatCurrency(calculateEarnings(values))}
                      </span>
                      / year
                    </div>
                    <Row>
                      <div className="mt-2">
                        <OverlayTrigger
                          placement="top"
                          trigger="hover"
                          delay={{ show: 150, hide: 250 }}
                          overlay={
                            <Tooltip style={{ zIndex: 9999999999 }}>
                              <>
                                Taabl Fee = 6% of Taabl's Contribution
                                <br />
                                <br /> Your Expected Earnings = Stock Purchased
                                - Taabl's Contribution & Taabl Fee
                              </>
                            </Tooltip>
                          }
                        >
                          <div className="d-flex align-items-center">
                            <div className="form-calculator">
                              How is this calculated?
                            </div>
                            <FaInfoCircle
                              style={{
                                marginLeft: "5px",
                              }}
                            />
                          </div>
                        </OverlayTrigger>
                      </div>
                    </Row>
                    <Link to="/taablsignup" className="secondary">
                      <LoaderButton
                        size="lg"
                        block
                        className={isValid ? "mt7" : "mt3"}
                        id="save"
                        variant="primary"
                      >
                        Sign Up Now
                      </LoaderButton>
                    </Link>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default calculator;
